module.exports = __webpack_public_path__ + "images/emoji/books.824c2398df0fe8cb7915.png";